const openScheme = (url) => window.HiyaJSBridge.callHandler("openScheme", { url });
openScheme.Ts = (data) => {
  const { url, ...rest } = data;
  const temp = Object.entries(rest).map(([k, v]) => `${k}=${typeof v === "object" ? encodeURIComponent(JSON.stringify(v)) : v}`);
  openScheme(`hiya://openWindow?${[...temp, `url=${url}`].join("&")}`);
};
openScheme.External = (data) => {
  openScheme.Ts({
    ...data,
    external: 1
  });
};
openScheme.Nav = (data) => {
  openScheme.Ts({
    need_user_info: 1,
    disable_native_gesture: 1,
    ...data,
    external: 0,
    fullscreen: 0
  });
};
openScheme.Full = (data) => {
  openScheme.Ts({
    need_user_info: 1,
    disable_native_gesture: 1,
    ...data,
    external: 0,
    fullscreen: 1
  });
};
openScheme.Half = (data) => {
  openScheme.Ts({
    need_user_info: 1,
    disable_native_gesture: 1,
    ...data,
    external: 0,
    fullscreen: 2
  });
};
openScheme.Alert = (data) => {
  openScheme.Ts({
    need_user_info: 1,
    disable_native_gesture: 1,
    ...data,
    external: 0,
    fullscreen: 3
  });
};
export {
  openScheme
};
